module.exports = __webpack_public_path__ + "img/logo-new.17f1143c.png";